// extracted by mini-css-extract-plugin
module.exports = {"legalHeader":"legalPage_legalHeader__cbyQF","contentWidth":"legalPage_contentWidth__fp6YO"};